var CryptoJS = require("crypto-js");

// AUX FUNC #1
function string_as_unicode_escape(str) {
  return str
    .split("")
    .map(function (s) {
      return "\\u" + ("0000" + s.charCodeAt(0).toString(16)).slice(-4);
    })
    .join("");
}

// AUX FUNC #2
function string_as_unicode_v2(str) {
  str = unescape_v2(str);
  var res = "";
  for (var i = 0; i < str.length; i++)
    res += str.charCodeAt(i).toString(16).slice(-4);
  return res;
}

// AUX FUNC #3
function unicode_as_string(str) {
  var tmp = str.match(/.{1,2}/g);
  var res = "";
  for (var i = 0; i < tmp.length; i++)
    res += String.fromCharCode(parseInt(tmp[i], 16));
  return res;
}

// AUX FUNC #4
function unescape_v2(_data) {
  var x = _data;
  var r = /\\u([\d\w]{4})/gi;
  x = x.replace(r, function (match, grp) {
    return String.fromCharCode(parseInt(grp, 16));
  });
  return unescape(x);
}

// ENCRYPT
export function Encrypt(_plain_text, _plain_key) {
  var key = CryptoJS.enc.Utf8.parse(_plain_key);
  var data = string_as_unicode_escape(_plain_text.toString(CryptoJS.enc.Utf8));
  var tmp = string_as_unicode_v2(data).toUpperCase();
  var encrypted = CryptoJS.AES.encrypt(tmp, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.ZeroPadding,
  });
  return encrypted.toString();
}

// DECRYPT
export function Decrypt(_plain_text, _plain_key) {
  var key = CryptoJS.enc.Utf8.parse(_plain_key);
  var text = _plain_text.toString("utf8");
  text = text.replace(/\s/g, "+"); // substitui espaços por '+'
  try {
    var decrypted = CryptoJS.AES.decrypt(text, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.ZeroPadding,
    });
    var tmp = CryptoJS.enc.Utf8.stringify(decrypted).toLowerCase();
    var res = unicode_as_string(tmp);
    return res;
  } catch (e) {
    return e.message;
  }
}
